import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { AuthService } from "../../../core/guards/auth/auth.service";
import { ActivatedRoute, Router } from '@angular/router';
import { ActivateService } from '../activate/activate.service';
import { SubscriptionService } from '../../../modules/subscription/subscription.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';import { SubscriptionListComponent } from '../../../modules/subscription/subscriptionList.component';
import { SubscriptionModel } from '../../../modules/subscription/subscription.model';
import { GetUserInfo, LocalDB } from "../../../shared/utils";
import { animate, createDrawable, createMotionPath, createScope, createTimeline, Scope, stagger } from 'animejs';

@Component({
    selector: 'convfact-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [SubscriptionService],
    standalone: false
})

export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
    email: string;
    password: string;
    activated: boolean = true;
    uid: string;
    ready: boolean = false;
    loginSpinner = false;
    showNewPassword: boolean = false;
    rememberMe = false;
    loginError = '';
    readonly today = new Date();

    private networkScope?: Scope;
    private pointerCleanup?: () => void;

    subscriptionList: SubscriptionModel[] = [];

    constructor(private authService: AuthService, private activateService: ActivateService, private route: ActivatedRoute,
        private router: Router, public snackBar: MatSnackBar, private subscriptionService: SubscriptionService, public dialog: MatDialog,
        private elRef: ElementRef<HTMLElement>, private zone: NgZone) {

    }

    forgot() {
        this.router.navigate(['/forgot']);
    }

    register() {
        this.router.navigate(['/register']);
    }

    developers() {
        this.router.navigate(['/developers']);
    }

    openDialog(login: boolean): void {
        this.dialog.open(SubscriptionListComponent, {
            data: { login: login }
        })
            .afterClosed().subscribe(result => this.ngOnInit())
    }

    displayError(error: string): void {
        this.loginError = error;
        const options = new MatSnackBarConfig();
        options.duration = 10500;
        this.snackBar.open(error, '', options);
    }

    login(): void {
        LocalDB.RemoveForFiles();
        this.loginError = '';
        this.loginSpinner = true;
        this.authService.login(this.email, this.password).then(
            result => {
                if (result && result.error) {
                    if (result.message) {
                        this.displayError(result.message);
                    } else {
                        this.displayError("Usuario/Contraseña no válidos");
                    }
                    this.loginSpinner = false;

                    return;
                }

                this.subscriptionService.getSubscriptionList()
                    .then(data => {
                        this.loginSpinner = false;
                        let initialModule = "/resume"
                        if (data != null && data.find(f => f.isActive) != null) {
                            initialModule = data.find(f => f.isActive).initialModule;
                        }
                        const target = (this.authService.redirectAfterLogin && this.authService.redirectAfterLogin.length >= 1)
                            ? this.authService.redirectAfterLogin
                            : initialModule;
                        this.authService.redirectAfterLogin = null;
                        this.router.navigate([target]);
                    })
                    .catch(data => {
                        if (data.message) {
                            this.displayError(data.message);
                        } else {
                            this.displayError("Usuario/Contraseña no válidos");
                        }
                        this.loginSpinner = false;
                    })

            })
            .catch(err => {
                this.loginSpinner = false;
                if (err.message) {
                    this.displayError(err.message);
                } else {
                    this.displayError("Usuario/Contraseña no válidos");
                }
            }
            );
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.uid = params['uid'];
        })

        if (this.uid == undefined) {
            this.ready = true;
        }

        if (this.uid !== undefined) {
            if (this.uid.length === 36) {
                this.activateService.activate(this.uid).then(response => {
                    this.activated = response;
                    this.ready = true;
                    const options = new MatSnackBarConfig();
                    options.duration = 10000;
                    this.snackBar.open("Su cuenta ha sido activada", '', options);
                });
            } else {
                this.router.navigate(['/login']);
            }
        }

    }


    showPassword(input: any): any {
        input.type = input.type === 'password' ? 'text' : 'password';
        this.showNewPassword = !this.showNewPassword;
    }

    ngAfterViewInit(): void {
        this.initNetworkAnimation();
        this.initPointerEffects();
    }

    ngOnDestroy(): void {
        this.networkScope?.revert();
        this.pointerCleanup?.();
    }

    private initPointerEffects(): void {
        const brand = this.elRef.nativeElement.querySelector<HTMLElement>('.fct-brand');
        if (!brand || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        this.zone.runOutsideAngular(() => {
            let frame = 0;
            let last: PointerEvent | null = null;

            const apply = () => {
                frame = 0;
                if (!last) { return; }
                const rect = brand.getBoundingClientRect();
                const x = last.clientX - rect.left;
                const y = last.clientY - rect.top;
                brand.style.setProperty('--mx', `${x}px`);
                brand.style.setProperty('--my', `${y + brand.scrollTop}px`);
                brand.style.setProperty('--px', ((x / rect.width) * 2 - 1).toFixed(3));
                brand.style.setProperty('--py', ((y / rect.height) * 2 - 1).toFixed(3));
                brand.style.setProperty('--spot', '1');
            };

            const onMove = (event: PointerEvent) => {
                last = event;
                if (!frame) { frame = requestAnimationFrame(apply); }
            };

            const onLeave = () => {
                last = null;
                brand.style.setProperty('--px', '0');
                brand.style.setProperty('--py', '0');
                brand.style.setProperty('--spot', '0.45');
            };

            brand.addEventListener('pointermove', onMove, { passive: true });
            brand.addEventListener('pointerleave', onLeave);

            this.pointerCleanup = () => {
                brand.removeEventListener('pointermove', onMove);
                brand.removeEventListener('pointerleave', onLeave);
                if (frame) { cancelAnimationFrame(frame); }
            };
        });
    }

    private initNetworkAnimation(): void {
        try {
            this.networkScope = createScope({
                root: this.elRef,
                mediaQueries: { reduceMotion: '(prefers-reduced-motion: reduce)' }
            }).add(scope => {
                const root = this.elRef.nativeElement;
                const lines = Array.from(root.querySelectorAll<SVGPathElement>('.fct-network__line'));
                const mesh = Array.from(root.querySelectorAll<SVGPathElement>('.fct-network__mesh'));
                const pulses = Array.from(root.querySelectorAll<SVGCircleElement>('.fct-network__pulse'));

                if (scope.matches['reduceMotion']) {
                    root.querySelectorAll<HTMLElement>('.fct-network__hub, .fct-network__node, .fct-network__label, .fct-network__orbit')
                        .forEach(el => { el.style.opacity = '1'; });
                    [...lines, ...mesh].forEach(line => { line.style.strokeDashoffset = '0'; });
                    return;
                }

                root.querySelector('.fct-login')?.classList.add('fct-login--motion');
                this.animateHeadline(root);
                this.animateWidget(root);
                this.animateToasts(root);

                createTimeline({ defaults: { ease: 'outQuad' } })
                    .add('.fct-network__hub', { opacity: [0, 1], scale: [0, 1], duration: 500, ease: 'outElastic(1, .6)' })
                    .add(createDrawable(lines), { draw: ['0 0', '0 1'], duration: 650, delay: stagger(140), ease: 'inOutQuad' }, '-=250')
                    .add('.fct-network__node', { opacity: [0, 1], scale: [0, 1], duration: 450, delay: stagger(140), ease: 'outBack(1.6)' }, '-=600')
                    .add('.fct-network__label', { opacity: [0, 1], translateY: [4, 0], duration: 400, delay: stagger(140) }, '-=450')
                    .add(createDrawable(mesh), { draw: ['0 0', '0 1'], duration: 500, delay: stagger(90), ease: 'inOutQuad' }, '-=250')
                    .add('.fct-network__orbit', { opacity: [0, 1], duration: 500 }, '-=400');

                // Latido del hub
                animate('.fct-network__hub', {
                    scale: [1, 1.12, 1],
                    duration: 1800,
                    loop: true,
                    delay: 2200,
                    ease: 'inOutSine'
                });

                // Anillo orbital girando sin cesar alrededor del hub
                animate('.fct-network__orbit', {
                    rotate: 360,
                    duration: 9000,
                    loop: true,
                    ease: 'linear'
                });

                // Ondas de radar emitidas desde el hub
                animate('.fct-network__ping', {
                    r: [14, 40],
                    opacity: [0.55, 0],
                    duration: 2400,
                    loop: true,
                    delay: stagger(800, { start: 1800 }),
                    ease: 'outSine'
                });

                // Dos pulsos por línea, desfasados en el tiempo, flujo continuo hub ↔ nodo
                lines.forEach((line, i) => {
                    const { translateX, translateY } = createMotionPath(line);
                    const baseDelay = 1600 + i * 260;
                    const linePulses = [pulses[i * 2], pulses[i * 2 + 1]];
                    linePulses.forEach((pulse, j) => {
                        if (!pulse) { return; }
                        animate(pulse, {
                            translateX, translateY,
                            scale: [0.4, 1, 0.4],
                            opacity: [0, 1, 1, 0],
                            duration: 1700,
                            loop: true,
                            delay: baseDelay + j * 850,
                            ease: 'inOutSine'
                        });
                    });
                });
            });
        } catch (e) {
            this.elRef.nativeElement.querySelector('.fct-login')?.classList.remove('fct-login--motion');
            console.warn('No se pudo iniciar la animación del panel de marca', e);
        }
    }

    private animateHeadline(root: HTMLElement): void {
        animate(root.querySelectorAll('.fct-word'), {
            opacity: [0, 1],
            translateY: [18, 0],
            filter: ['blur(6px)', 'blur(0px)'],
            duration: 700,
            delay: stagger(70, { start: 150 }),
            ease: 'outExpo'
        });

        const swash = root.querySelector<SVGPathElement>('.fct-hl__swash path');
        if (swash) {
            animate(createDrawable(swash), {
                draw: ['0 0', '0 1'],
                opacity: [0, 0.85],
                duration: 900,
                delay: 750,
                ease: 'inOutQuart'
            });
        }
    }

    private animateWidget(root: HTMLElement): void {
        const line = root.querySelector<SVGPathElement>('.fct-widget__chart-line');
        if (line) {
            animate(createDrawable(line), { draw: ['0 0', '0 1'], opacity: [0, 1], duration: 1300, delay: 650, ease: 'inOutCubic' });
        }
        animate(root.querySelectorAll('.fct-widget__chart-area'), { opacity: [0, 1], duration: 900, delay: 1300, ease: 'outQuad' });
        animate(root.querySelectorAll('.fct-widget__chart-dot'), {
            opacity: [0, 1],
            scale: [0, 1],
            duration: 500,
            delay: 1850,
            ease: 'outBack(2)'
        });

        const money = {
            format: (value: number) => {
                const [int, dec] = value.toFixed(2).split('.');
                return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`;
            }
        };
        root.querySelectorAll<HTMLElement>('.fct-count').forEach((el, i) => {
            const target = Number(el.dataset['value']);
            if (!Number.isFinite(target)) { return; }
            const counter = { value: 0 };
            el.textContent = `${money.format(0)} €`;
            animate(counter, {
                value: target,
                duration: 1600,
                delay: 600 + i * 150,
                ease: 'outExpo',
                onUpdate: () => { el.textContent = `${money.format(counter.value)} €`; }
            });
        });
    }

    private animateToasts(root: HTMLElement): void {
        const toasts = Array.from(root.querySelectorAll<HTMLElement>('.fct-toast'));
        if (!toasts.length) { return; }

        const timeline = createTimeline({ loop: true, delay: 2400 });
        toasts.forEach(toast => {
            timeline
                .add(toast, { opacity: [0, 1], translateY: [10, 0], scale: [0.96, 1], duration: 450, ease: 'outBack(1.4)' })
                .add(toast, { opacity: [1, 0], translateY: [0, -8], duration: 350, ease: 'inQuad' }, '+=2600');
        });
    }

}
